var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext, useEffect, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { DEFAULT_API, MAX_SIMULTANEOUS_FILE_UPLOADS } from '../constants';
import ApiContext from '../contexts/apiContext';
import { deleteFile, getApiSourceFiles, getApiSources, uploadFiles } from '../api';
import Combo from './Combo';
import Menu from './Menu';
import FileUploader from './FileUploader';
import ErrorDialog from './ErrorDialog';
import DataSourceFileList from './DataSourceFileList';
var API_OPTIONS = [
    {
        id: 'chatgpt',
        label: 'ChatGPT'
    },
    {
        id: 'gemini',
        label: 'Gemini'
    }
];
var EMPTY_LIST_FILES_RESULT = { files: [], truncated: false };
var DataSources = function () {
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(''), filter = _c[0], setFilter = _c[1];
    var _d = useState(), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useState(searchParams.get('api') || DEFAULT_API), selectedApi = _e[0], setSelectedApi = _e[1];
    var _f = useState(searchParams.has('sourceId') ? searchParams.get('sourceId') : undefined), selectedDataSourceId = _f[0], setSelectedDataSourceId = _f[1];
    var _g = useState(EMPTY_LIST_FILES_RESULT), listFilesResult = _g[0], setListFilesResult = _g[1];
    var _h = useState([]), files = _h[0], setFiles = _h[1];
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    useEffect(function () {
        setSelectedDataSourceId(undefined);
        updateSearchParams();
    }, [selectedApi]);
    useEffect(function () {
        refreshFileList();
        updateSearchParams();
    }, [selectedDataSourceId]);
    var refreshFileList = function () {
        setListFilesResult(EMPTY_LIST_FILES_RESULT);
        setFiles([]);
        if (selectedDataSourceId) {
            setLoading(true);
            getApiSourceFiles(apiBaseUrl, selectedApi, selectedDataSourceId)
                .then(function (result) {
                setListFilesResult(result);
                setFiles(result.files);
            })
                .catch(function (err) {
                // eslint-disable-next-line no-console
                console.error(err);
            })
                .finally(function () { return setLoading(false); });
        }
    };
    var fetchDataSourceOptions = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var apiSources;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getApiSources(apiBaseUrl, selectedApi, 'blobstorage')];
                case 1:
                    apiSources = _a.sent();
                    return [2 /*return*/, Object.entries(apiSources).map(function (_a) {
                            var id = _a[0], label = _a[1];
                            return ({ id: id, label: label });
                        })];
            }
        });
    }); }, [selectedApi]);
    var buildDownloadUrl = function (name) {
        return "".concat(apiBaseUrl, "/apis/").concat(selectedApi, "/sources/").concat(selectedDataSourceId, "/files/").concat(encodeURIComponent(name));
    };
    var updateSearchParams = function () {
        var newSearchParams = new URLSearchParams();
        newSearchParams.set('api', selectedApi);
        if (selectedDataSourceId) {
            newSearchParams.set('sourceId', selectedDataSourceId);
        }
        setSearchParams(newSearchParams);
    };
    var handleDeleteFile = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (selectedDataSourceId) {
                deleteFile(apiBaseUrl, selectedApi, selectedDataSourceId, name)
                    .then(function () { return refreshFileList(); })
                    .catch(function (err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                });
            }
            return [2 /*return*/];
        });
    }); };
    var handleUploadFiles = function () {
        var file = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            file[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedDataSourceId) return [3 /*break*/, 2];
                        return [4 /*yield*/, uploadFiles(apiBaseUrl, selectedApi, selectedDataSourceId, file)];
                    case 1:
                        result = _a.sent();
                        if (result.errors) {
                            setErrorMessage("The following files failed to be uploaded, please try again and if the error persists contact Support: ".concat(result.failedNames.join(', ')));
                        }
                        refreshFileList();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    var handleErrorDialogClose = function () { return setErrorMessage(undefined); };
    var handleFilterChange = function (e) {
        var newFilter = e.target.value;
        setFilter(newFilter);
        if (newFilter.trim()) {
            setFiles(listFilesResult.files.filter(function (file) { return file.name.toLocaleLowerCase().includes(newFilter.toLocaleLowerCase()); }));
        }
        else {
            setFiles(listFilesResult.files);
        }
    };
    var footer = (_jsx(Button, { variant: "outlined", component: Link, startIcon: _jsx(ArrowBackIcon, {}), to: "/", sx: { ml: 2, mr: 2, mt: 2 }, children: "Back" }));
    return (_jsxs(Box, { display: "flex", justifyContent: "center", pt: 3, children: [_jsx(ErrorDialog, { message: errorMessage, onClose: handleErrorDialogClose }), _jsx(Menu, { footer: footer, children: _jsx(Box, { flexGrow: 1 }) }), _jsxs(Stack, { spacing: 2, width: 1024, children: [_jsxs(Stack, { spacing: 2, direction: "row", children: [_jsx(Box, { flexGrow: 1, children: _jsx(Combo, { label: "Model", selectedOptionId: selectedApi, setSelectedOptionId: function (api) {
                                        if (api === void 0) { api = DEFAULT_API; }
                                        return setSelectedApi(api);
                                    }, fetchOptions: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                        return [2 /*return*/, API_OPTIONS];
                                    }); }); } }) }), _jsx(Box, { flexGrow: 1, children: _jsx(Combo, { label: "Data source", selectedOptionId: selectedDataSourceId, setSelectedOptionId: function (dataSourceId) { return setSelectedDataSourceId(dataSourceId); }, fetchOptions: fetchDataSourceOptions }) })] }), _jsx(FileUploader, { disabled: !selectedDataSourceId, disabledText: "Please select a data source to add files", maxFiles: MAX_SIMULTANEOUS_FILE_UPLOADS, uploadFiles: handleUploadFiles }), _jsx(TextField, { disabled: !selectedDataSourceId, label: "Filter by name", value: filter, onChange: handleFilterChange, sx: { alignSelf: 'flex-end', width: 300 }, InputProps: {
                            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { edge: "end", children: _jsx(FilterAltIcon, {}) }) }))
                        } }), loading && (_jsx(Box, { alignSelf: "center", children: _jsx(CircularProgress, {}) })), listFilesResult.truncated && (_jsx(Alert, { severity: "warning", children: "Results have been truncated, not all files are shown" })), !loading && (_jsx(DataSourceFileList, { files: files, handleDeleteFile: handleDeleteFile, buildDownloadUrl: buildDownloadUrl }))] })] }));
};
export default DataSources;
